import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { Observable, from, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClientaccountService {

  // Client account actuel
  currClientAccount: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private baseClient: BaseclientService
  ) { }

  /**
   * @description Retourne le subject currClientAccount en observable
   * @return {Observable}
   */
  getCurrClientAccount(): Observable<any> {
    return this.currClientAccount.asObservable();
  }

  /**
 * @description Set le subject currClientAccount
 * @param {clientaccount} clientaccount Object client account
 * @return {Void}
 */
  setCurrClientAccount(clientaccount: any): void {
    this.currClientAccount.next(clientaccount);
  }

  /**
   * @description Crée le client account coté base de donnée
   * @param {string} phone 
   * @param {number} countryId 
   * @param {string} firstname 
   * @param {string} lastname 
   * @return {Promise}
   */
  createClientAccount(phone: string, countryId: number, firstname: string, lastname: string, enable_marketing: number,society?:any): Promise<any> {
    const params = {
      phone: phone,
      id_country: countryId,
      firstname: firstname,
      lastname: lastname,
      enable_marketing: enable_marketing,
      society:society
    }
    return this.baseClient.postBase("createClient", params);
  }

  /**
   * @description Récupère les données du client de la base de donnée via le token firebase et set le client account actuel
   * @return {Observable}
   */
  getClientAccount(): Observable<any> {
    return from(this.baseClient.getBase("getClient")).pipe(
      map(data => {
        this.currClientAccount.next(data.client);
        return data.client;
      })
    );
  }


  /**
   * @description Met à jour le client account coté base de donnée
   * @param {object} param Ex: { mail:mail } | {firstname:firstname} ... 
   * @return {Promise}
   */
  updateClientAccount(param: any): Promise<any> {
 
    return this.baseClient.postBase("updateClient", param);
  }


 /**
   * @description archive le client
   * @param {object} param Ex: uid ... 
   * @return {Promise}
   */
 deleteClientAccount(param: any): Promise<any> {

  return this.baseClient.postBase("deleteClient", param);
}
  
  

}
